module.exports = __webpack_public_path__ + "static/img/meitinew2.0fe1e53b.png";